module.exports = __webpack_public_path__ + "img/qita.a9c91012.jpg";